import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { Dispatch, SetStateAction } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { compose } from 'redux';
import { pageLeftThunk } from '@redux/analytics/analyticsThunks';
import { PageType } from '@redux/analytics/analyticsTypes';
import { acceptInviteThunk, acceptInviteThunkV2, loginThunk, requestSmsVerificationThunk } from '@redux/oauth/oauthThunks';
import { AcceptAccountInviteRequest, LoginPayload } from '@redux/oauth/oauthTypes';
import { getQueryParamObject } from 'utils/util';
import { DualPane } from '../../components/DualPane/DualPane';
import { DevicePane } from '../../components/DualPane/Panes/DevicePane/DevicePane';
import { DevicePaneV2 } from '../../components/DualPane/Panes/DevicePaneV2/DevicePaneV2';
import { FinishCreateAccountPane } from '../../components/DualPane/Panes/FinishCreateAccountPane/FinishCreateAccountPane';
import { FinishCreateAccountPaneV2 } from '../../components/DualPane/Panes/FinishCreateAccountPaneV2/FinishCreateAccountPaneV2';
import { DualPaneV2 } from '../../components/DualPaneV2/DualPaneV2';

interface Props {
  acceptInvite: Function;
  acceptInviteV2: Function;
  login: Function;
  pageLeft: Function;
  requestSmsVerification: Function;
}

const InviteAccount: React.FC<Props> = ({ acceptInvite, acceptInviteV2, login, pageLeft, requestSmsVerification }) => {
  const flags = useFlags();
  const location = useLocation();
  const useNewSignupFlow = flags?.newSignupFlow ?? false;
  let isNewSignupFlow = getQueryParamObject(location?.search)?.isNewSignupFlow === 'true';
  const token = getQueryParamObject(location?.search)?.token;
  const email = getQueryParamObject(location?.search)?.email;

  if (token && email) {
    sessionStorage.setItem('isNewSignupFlow', isNewSignupFlow ? 'true' : 'false');
  } else {
    const storedValue = sessionStorage.getItem('isNewSignupFlow');
    if (storedValue === 'true') {
      isNewSignupFlow = true;
      sessionStorage.removeItem('isNewSignupFlow');
    }
  }

  if (useNewSignupFlow && isNewSignupFlow) {
    return (
      <DualPaneV2
        pageLeft={pageLeft}
        pageType={PageType.INVITE_BY_TOKEN}
        leftPane={(loadingState: [boolean, Dispatch<SetStateAction<boolean>>], handleExternalRouting: (url?: Nullable<string>) => void, handleError: (err: any) => void) => (
          <FinishCreateAccountPaneV2
            acceptInvite={acceptInviteV2}
            login={login}
            requestSmsVerification={requestSmsVerification}
            loadingState={loadingState}
            handleError={handleError}
            handleExternalRouting={handleExternalRouting}
          />
        )}
        rightPane={<DevicePaneV2 />}
      />
    );
  }

  return (
    <DualPane
      pageLeft={pageLeft}
      pageType={PageType.INVITE_BY_TOKEN}
      leftPane={<DevicePane />}
      rightPane={(loadingState: [boolean, Dispatch<SetStateAction<boolean>>], handleExternalRouting: (url?: Nullable<string>) => void, handleError: (err: any) => void) => (
        <FinishCreateAccountPane acceptInvite={acceptInvite} loadingState={loadingState} handleError={handleError} handleExternalRouting={handleExternalRouting} />
      )}
    />
  );
};

const connectRedux = connect(
  () => {
    return {};
  },
  (dispatch: Function) => ({
    acceptInvite: async (acceptAccountInviteRequest: AcceptAccountInviteRequest, token: any) => {
      return dispatch(acceptInviteThunk(token, acceptAccountInviteRequest));
    },
    acceptInviteV2: async (acceptAccountInviteRequest: AcceptAccountInviteRequest, token: any) => {
      return dispatch(acceptInviteThunkV2(token, acceptAccountInviteRequest));
    },
    login: async (loginPayload: LoginPayload) => {
      return dispatch(loginThunk(loginPayload));
    },
    requestSmsVerification: async (token: string, phoneNumber: string) => {
      return dispatch(requestSmsVerificationThunk(token, phoneNumber));
    },
    pageLeft: async (pageType: PageType) => {
      return dispatch(pageLeftThunk(pageType));
    }
  })
);

export default compose(connectRedux)(InviteAccount);
